import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { CheckboxFieldset } from "@interdependence-ui";
import { isEmptyArray } from "utils/validation";
import { extractMeasurementProp } from "utils/measurement";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function GraphAdditions(props) {
  var _metadata$targetMeasu, _measurementsWithMeta;
  var query = props.query,
    setQuery = props.setQuery,
    metadata = props.metadata,
    measurementsWithMetadata = props.measurementsWithMetadata;
  var isBarchart = query.graphSelected === "barchart";
  var isNotProcent = (metadata === null || metadata === void 0 ? void 0 : metadata.measureUnit) !== "%";
  var graphSelected = isBarchart && isNotProcent && query.measureIds.length > 1 ? "stackedBarchart" : query.graphSelected;
  var allowedAdditions = query.graphSelected === "timeline" ? ["showTarget", "zoom"] : graphSelected === "stackedBarchart" ? [] : ["showTarget", "showReich", "showCi", "showPrevious", "zoom"];
  if (isEmptyArray(allowedAdditions)) return null;
  var targetDisabled = !((metadata === null || metadata === void 0 ? void 0 : (_metadata$targetMeasu = metadata.targetMeasurements) === null || _metadata$targetMeasu === void 0 ? void 0 : _metadata$targetMeasu.length) > 0);
  var reichDisabled = !query.units.includes("SE") && !query.units.includes("se");
  var kiDisabled = ((_measurementsWithMeta = measurementsWithMetadata.get(metadata === null || metadata === void 0 ? void 0 : metadata.parentMeasure)) === null || _measurementsWithMeta === void 0 ? void 0 : _measurementsWithMeta.flatMap(function (x) {
    var _x$measurements;
    return (_x$measurements = x.measurements) === null || _x$measurements === void 0 ? void 0 : _x$measurements.map(extractMeasurementProp.confidenceInterval);
  }).filter(function (x) {
    return x && x !== "-";
  }).length) === 0;
  var options = [{
    id: "showTarget",
    label: "Målvärde",
    checked: query.showTarget,
    disabled: targetDisabled
  }, {
    id: "showReich",
    label: "Rikssnitt",
    checked: query.showReich && !reichDisabled,
    disabled: reichDisabled
  }, {
    id: "showCi",
    label: "Konfidensintervall",
    checked: query.showCi && !kiDisabled,
    disabled: kiDisabled
  }, {
    id: "showPrevious",
    label: "Föregående värde",
    checked: query.showPrevious
  }, {
    id: "zoom",
    label: "Zoom",
    checked: query.zoom
  }].filter(function (x) {
    return allowedAdditions.includes(x.id);
  });
  return /*#__PURE__*/_jsx(CheckboxFieldset, _objectSpread({
    id: "graph-additions",
    legend: "Till\xE4gg till diagrammet",
    options: options,
    name: "graphadditions",
    updateSelected: function updateSelected(show, id) {
      return setQuery(_defineProperty({}, id, show));
    },
    icon: "goal",
    mb: "10px"
  }, extendedSystemStylesProps(styledSystemKeys, props)));
}, function (prev, curr) {
  return equals(prev.query, curr.query) && equals(prev.metadata, curr.metadata) && equals(prev.measurementsWithMetadata, curr.measurementsWithMetadata);
});